// Module
var code = "<vf-button><slot>{{ text }}</slot></vf-button> ";
// Exports
export default code;